function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { createOwnUpComponent } from '../components/components';
import { createOwnUpStyle } from '../components/style';
import { AdvisorProvider } from '../hooks/use-advisors/advisor-provider';
import { BreakpointsProvider } from '../hooks/use-breakpoints/breakpoints-provider';
import { ScreenSizeProvider } from '../hooks/use-screen-size/screen-size-provider';
import { buildClassNames } from '../modules/css-helpers';
// Applied to the entire page.
var OwnUpGlobalStyle = createGlobalStyle({
  body: {
    overflowX: 'hidden',
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0
  }
});
/**
 * Applied to the div wrapping the whole app frame
 */

var OwnUpThemeWrapperStyle = createOwnUpStyle({
  width: '100%',
  height: '100%',
  margin: 0,
  padding: 0
});
/**
 * Own Up Theme Wrapper component properties.
 */

var StyledThemeWrapper = createOwnUpComponent('div', OwnUpThemeWrapperStyle);
/**
 *
 * Applies the core stylesheet to all child elements.
 *
 * @param param0 See {@link OwnUpThemeWrapperProps}
 */

export var OwnUpThemeWrapper = function OwnUpThemeWrapper(_ref) {
  var className = _ref.className,
      breakpoints = _ref.breakpoints,
      _ref$preload_advisors = _ref.preload_advisors,
      preload_advisors = _ref$preload_advisors === void 0 ? true : _ref$preload_advisors,
      props = _objectWithoutProperties(_ref, ["className", "breakpoints", "preload_advisors"]);

  var classes = buildClassNames('ou-theme', className);
  var content = /*#__PURE__*/React.createElement(ScreenSizeProvider, {
    breakpoints: breakpoints
  }, /*#__PURE__*/React.createElement(BreakpointsProvider, {
    breakpoints: breakpoints
  }, /*#__PURE__*/React.createElement(OwnUpGlobalStyle, null), /*#__PURE__*/React.createElement(StyledThemeWrapper, _extends({
    className: classes
  }, props))));
  return preload_advisors ? /*#__PURE__*/React.createElement(AdvisorProvider, null, content) : content;
};